/*
 * IMPORTS
 */
import React from 'react' // Npm: react.js library.
import PropTypes from 'prop-types' // Npm: react.js library.
import { connect } from 'react-redux' // Npm: React Redux for state management.
import { useHistory } from 'react-router-dom' // Npm: React router dom.
import { HiArrowPathRoundedSquare, HiCurrencyEuro, HiFire, HiLockClosed, HiMiniBoltSlash, HiMiniRocketLaunch, HiPencil, HiServer, HiTrash, HiUsers } from 'react-icons/hi2' // Npm: React icons.
import {
  IconButton,
  Menu,
  MenuItem
} from '@mui/material' // Npm: Material UI components.


/*
 * OBJECTS
 */
const Index = ({
  customerId,
  type,
  currency,
  onCustomerNotify,
  onCustomerUpdate,
  onCustomerDelete,
  onCustomerBlockDuration,
  onRateAndRoutePlanAttach,
  onAttachAccountManager,
  onCreditManagementUpsert,
  onCustomerPasswordChange,
  onCustomerChangeTps,
  PassOnUpdate
}) => {
  // Hook assignment.
  const _historyRef = useHistory()
  const [_anchorEl, _setAnchorEl] = React.useState(null)
  const _open = Boolean(_anchorEl)

  const _handleClick = (event) => {
    _setAnchorEl(event.currentTarget)
  }

  const _handleClose = () => {
    _setAnchorEl(null)
  }

  // Return component.
  return (
    <>
      <IconButton
        onClick={_handleClick}
        sx={{
          margin: 'auto',
          borderRadius: '8px',
          color: 'gray.500',
          backgroundColor: 'transparent'
        }}>
        <HiPencil size={18} />
      </IconButton>
      <Menu
        anchorEl={_anchorEl}
        open={_open}
        onClose={_handleClose}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}

      >
        <MenuItem
          onClick={() => {
            // Push customer id to url.
            PassOnUpdate({ customerId, type })

            // Execute handler.
            onCustomerUpdate()

            _handleClose()
          }}
          sx={{
            gap: '12px',
            display: 'flex',
            pl: '20px',
            pr: '20px',
            color: 'gray.500',
            minHeight: '40px'
          }}>
          <HiPencil size={18} />
          <span>Edit Customer</span>
        </MenuItem>
        <MenuItem
          onClick={() => {
            // Push customer id to url.
            PassOnUpdate({ customerId, type })

            // Execute handler.
            onCustomerNotify()

            _handleClose()
          }}
          sx={{
            gap: '12px',
            display: 'flex',
            pl: '20px',
            pr: '20px',
            color: 'gray.500',
            minHeight: '40px'
          }}>
          <HiFire size={18} />
          <span>Notify</span>
        </MenuItem>
        <MenuItem
          onClick={() => {
            // Push customer id to url.
            PassOnUpdate({ customerId, type })

            // Execute handler.
            onCustomerBlockDuration()

            _handleClose()
          }}
          sx={{
            gap: '12px',
            display: 'flex',
            pl: '20px',
            pr: '20px',
            color: 'gray.500',
            minHeight: '40px'
          }}>
          <HiMiniBoltSlash size={18} />
          <span>Block Traffic</span>
        </MenuItem>
        <MenuItem
          onClick={() => {
            // Push customer id to url.
            PassOnUpdate({ customerId, type })

            // Execute handler.
            onCustomerDelete()

            _handleClose()
          }}
          sx={{
            gap: '12px',
            display: 'flex',
            pl: '20px',
            pr: '20px',
            color: 'gray.500',
            minHeight: '40px'
          }}>
          <HiTrash />
          <span>Delete Customer</span>
        </MenuItem>
        <MenuItem
          disabled={!['RESELLER', 'RETAIL'].includes(type)}
          onClick={() => {
            // Push customer id to url.
            PassOnUpdate({ customerId, type })

            // Execute handler.
            onCustomerChangeTps()

            _handleClose()
          }}
          sx={{
            gap: '12px',
            display: 'flex',
            pl: '20px',
            pr: '20px',
            color: 'gray.500',
            minHeight: '40px'
          }}>
          <HiMiniRocketLaunch size={18} />
          <span>Change TPS</span>
        </MenuItem>
        <MenuItem
          disabled={['RESELLER', 'RETAIL'].includes(type)}
          onClick={() => {
            // Push customer id to url.
            PassOnUpdate({ customerId, type })

            // Execute handler.
            _historyRef.push('/customer/smpp')

            _handleClose()
          }}
          sx={{
            gap: '12px',
            display: 'flex',
            pl: '20px',
            pr: '20px',
            color: 'gray.500',
            minHeight: '40px'
          }}>
          <HiServer size={18} />
          <span>Manage SMPP Accounts</span>
        </MenuItem>
        <MenuItem
          onClick={() => {
            // Push customer id to url.
            PassOnUpdate({ customerId, type })

            // Execute handler.
            onAttachAccountManager()

            _handleClose()
          }}
          sx={{
            gap: '12px',
            display: 'flex',
            pl: '20px',
            pr: '20px',
            color: 'gray.500',
            minHeight: '40px'
          }}>
          <HiUsers size={18} />
          <span>Assign Account Manager</span>
        </MenuItem>
        <MenuItem
          disabled={'WHOLESALE' === type}
          onClick={() => {
            // Push customer id to url.
            PassOnUpdate({ customerId, type })

            // Execute handler.
            onRateAndRoutePlanAttach()

            _handleClose()
          }}
          sx={{
            gap: '12px',
            display: 'flex',
            pl: '20px',
            pr: '20px',
            color: 'gray.500',
            minHeight: '40px'
          }}>
          <HiArrowPathRoundedSquare size={18} />
          <span>Manage Rate & Route Plan</span>
        </MenuItem>
        <MenuItem
          onClick={() => {
            // Push customer id to url.
            PassOnUpdate({ customerId, type })

            // Execute handler.
            onCustomerPasswordChange()

            _handleClose()
          }}
          sx={{
            gap: '12px',
            display: 'flex',
            pl: '20px',
            pr: '20px',
            color: 'gray.500',
            minHeight: '40px'
          }}>
          <HiLockClosed size={18} />
          <span>Change Password</span>
        </MenuItem>
        <MenuItem
          onClick={() => {
            // Push customer id to url.
            PassOnUpdate({ customerId, type, currency })

            // Execute handler.
            onCreditManagementUpsert()

            _handleClose()
          }}
          sx={{
            gap: '12px',
            display: 'flex',
            pl: '20px',
            pr: '20px',
            color: 'gray.500',
            minHeight: '40px'
          }}>
          <HiCurrencyEuro size={18} />
          <span>Add Payment</span>
        </MenuItem>
      </Menu>
    </>
  )
}


/*
 * PROPTYPES
 */
Index.propTypes = {
  'currency': PropTypes.string,
  'type': PropTypes.oneOf([...Object.React.App.enums.CUSTOMER_TYPE.enums, ...Object.React.App.enums.VENDOR_TYPE.enums]?.map(i => i.key)),
  'onCustomerUpdate': PropTypes.func,
  'onCustomerDelete': PropTypes.func,
  'onCustomerPasswordChange': PropTypes.func,
  'onRateAndRoutePlanAttach': PropTypes.func,
  'customerId': PropTypes.string,
  'PassOnUpdate': PropTypes.func,
  'onAttachAccountManager': PropTypes.func,
  'onCreditManagementUpsert': PropTypes.func,
  'onCustomerNotify': PropTypes.func,
  'onCustomerBlockDuration': PropTypes.func,
  'onCustomerChangeTps': PropTypes.func
}


/*
 * REDUX
 */
const _MapDispatchToProps = __dispatch => ({
  'PassOnUpdate': u => __dispatch({ 'type': 'PASS_ON_UPDATE', 'PassOn': u })
})


/*
 * EXPORT
 */
export default connect(void 0, _MapDispatchToProps)(Index)
